import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { Place } from "src/app/interface/user";
import { Ninja, PlaceProfile } from "src/app/states/actions/user.actions";
import { UserState } from "src/app/states/user.state";
@Component({
  selector: "app-place",
  templateUrl: "./place.component.html",
  styleUrls: ["./place.component.scss"],
  standalone: false,
})
export class PlaceComponent implements OnInit {
  @Select(UserState.selectedPlace) selectedPlace: Observable<Place>;
  constructor(private route: ActivatedRoute, private store: Store) {}

  ngOnInit(): void {
    const { uid, FK_Place } = this.route.snapshot.params;
    this.store.dispatch(new PlaceProfile(FK_Place));
    this.store.dispatch(new Ninja(uid, FK_Place));
  }
}
